import { registerPlugin } from '@capacitor/core';

export interface PeriodCloseResult {
  merchantReceipt: string;
}

export interface Terminal {
  ipAddress: string;
  port: number;
  compatibilityPort: number;
  socketMode: string;
  terminalType: string;
}

interface PaymentTerminalPlugin {
  makePayment: (data: {amount: string; currency: string}) => Promise<void>;
  closePeriod: () => Promise<PeriodCloseResult>;
  checkHasConfiguredTerminal: () => Promise<{hasConfiguredTerminal: boolean}>;
  getAvailableTerminals: () => Promise<{availableTerminals: Terminal[]}>;
  setActiveTerminal: (data: {terminal: Terminal}) => Promise<void>;
}

const PaymentTerminal = registerPlugin<PaymentTerminalPlugin>('PaymentTerminal');

export default PaymentTerminal;
